import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { useWatch } from 'react-hook-form';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.ValueRange}`;

export interface IValueRangeRuleComponentProps {}

export function ValueRangeRuleComponent(props: IValueRangeRuleComponentProps) {
  // const {} = props;
  const minExclusive = useWatch({ name: `${fieldName}.minExclusive` });
  const maxExclusive = useWatch({ name: `${fieldName}.maxExclusive` });

  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Minimo"
        help={
          minExclusive
            ? 'Il numero si considera escluso.'
            : 'Il numero si considera incluso.'
        }
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
        <CheckboxInput
          name={`${fieldName}.minExclusive`}
          defaultChecked={false}
        >
          Escludi valore
        </CheckboxInput>
      </FormItem>

      <FormItem
        name={`${fieldName}.max`}
        label="Massimo"
        help={
          maxExclusive
            ? 'Il numero si considera escluso.'
            : 'Il numero si considera incluso.'
        }
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
        <CheckboxInput
          name={`${fieldName}.maxExclusive`}
          defaultChecked={false}
        >
          Escludi valore
        </CheckboxInput>
      </FormItem>
    </RowElement>
  );
}
